import { ICommonStore } from './interfaces';
import * as actionTypes from './actionTypes';
import { Area } from '@redux/common';

const initialState = {
    ETID: null,
    Foreign: null,
    Language: null,
    Currency: null,
    isLogin: false,
    isDisney: false, // 是否為迪士尼產品，目前使用在開光箱
    isGDS: null,
    isErpOrder: false, // 是否是電話單下單
    focusArea: Area.None,
    listStatus: null,
    ListData: null,
    // DetailFetchData: null,
    DetailFetchAllData: null,
    DetailFetchMonths: {}, // 重打機制判斷欄位，2023/04/11 後取消使用(與IT討論，決定改成切換月分都會重打)
    DetailFetchFailMsg: null,
    VerificationStatus: null,
    ProductDescKey: "",
    // 自建
    isTDetailCrossLoading: false,
    // GDS
    GListData: null,
    GDetailStore: null
};

const reducer = (state: ICommonStore = initialState, action: any) => {
    switch (action.type) {
        case actionTypes.SET_ETID:
            return { ...state, ETID: action.payload };
        case actionTypes.SET_FOREIGN:
            return { ...state, Foreign: action.payload };
        case actionTypes.SET_LANGUAGE:
            return { ...state, Language: action.payload };
        case actionTypes.SET_CURRENCY:
            return { ...state, Currency: action.payload };
        case actionTypes.SET_ISLOGIN:
            return { ...state, isLogin: action.payload };
        case actionTypes.SET_ISDISNEY:
            return { ...state, isDisney: action.payload };
        case actionTypes.SET_ISGDS:
            return { ...state, isGDS: action.payload };
        case actionTypes.SET_ISERPORDER:
            return { ...state, isErpOrder: action.payload };
        case actionTypes.SET_FOCUSAREA:
            return { ...state, focusArea: action.payload };
        case actionTypes.SET_LISTSTATUS:
            return { ...state, listStatus: action.payload };
        case actionTypes.SET_LISTDATA:
            return { ...state, ListData: action.payload };
        // case actionTypes.SET_DETAILFETCHDATA:
        //     return {
        //         ...state,
        //         DetailFetchData: action.payload,
        //         isTFetchingNormal: false,
        //     };
        case actionTypes.SET_DETAILFETCHALLDATA:
            return {
                ...state,
                DetailFetchAllData: action.payload,
                isTDetailCrossLoading: false,
            };
        case actionTypes.SET_DETAILFETCHMONTHS:
            return {...state, DetailFetchMonths: action.payload };
        case actionTypes.SET_DETAILFETCHFAILMSG:
            return {...state, DetailFetchFailMsg: action.payload };
        case actionTypes.SET_VERIFICATIONSTATUS:
            return {...state, VerificationStatus: action.payload };
        case actionTypes.SET_PRODUCTDESCKEY:
            return {...state, ProductDescKey: action.payload };
        // 自建
        case actionTypes.SET_ISTDETAILCROSSLOADING:
            return { ...state, isTDetailCrossLoading: action.payload };
        // GDS
        case actionTypes.SET_GLISTDATA:
            return { ...state, GListData: action.payload };
        case actionTypes.SET_GDETAILSTORE:
            return { ...state, GDetailStore: action.payload };
        default:
            return state;
    }
};

export default reducer;
